<div class="modal-header">
	<h2>
		<svg width="40" height="40" viewBox="0 0 40 40">
			<path d="M8.683 6.042h12.782a.797.797 0 0 0 .794-.799.797.797 0 0 0-.794-.799H8.683a.797.797 0 0 0-.794.8c0 .44.356.798.794.798M22.26 10.243a.797.797 0 0 0-.795-.799H8.683a.797.797 0 0 0-.794.8c0 .44.355.798.794.798h12.782a.797.797 0 0 0 .794-.799"/>
			<path d="M28.571 37.997c-5.32 0-9.647-4.175-9.647-9.306 0-5.132 4.328-9.307 9.647-9.307 5.32 0 9.648 4.175 9.648 9.307 0 5.131-4.328 9.306-9.648 9.306zM3.123 32.221c-.35 0-.646-.272-.646-.595V13.633c0-.322.296-.595.646-.595h9.389c.35 0 .646.273.646.595v.4c0 1.21 1.002 2.194 2.234 2.194h12.462c.35 0 .646.272.646.594v.967c-6.162.037-11.164 4.913-11.164 10.903 0 1.235.215 2.422.607 3.53H3.123zM5.778 2.042H25.2V14.63h-9.808c-.35 0-.646-.273-.646-.595v-.4c0-1.21-1.002-2.194-2.234-2.194H5.778V2.042zm24.31 15.846v-1.067c0-1.209-1.002-2.192-2.234-2.192h-1.066V1.243a.797.797 0 0 0-.794-.799H4.984a.797.797 0 0 0-.795.8V11.44H3.123c-1.232 0-2.234.984-2.234 2.193v17.993c0 1.21 1.002 2.193 2.234 2.193H18.66c1.894 3.434 5.626 5.776 9.912 5.776 6.196 0 11.236-4.891 11.236-10.904 0-5.514-4.238-10.081-9.718-10.803z"/>
			<path d="M28.94 27.963c-1.608-.643-2.293-1.109-2.293-2.041 0-.717.536-1.54 1.96-1.54 1.185 0 1.944.393 2.333.609l.463-1.182c-.538-.305-1.295-.59-2.406-.626v-1.739H27.85v1.81c-1.701.269-2.794 1.397-2.794 2.883 0 1.558 1.166 2.382 3.054 3.098 1.37.537 2.09 1.146 2.09 2.131 0 1.022-.887 1.755-2.202 1.755a5.052 5.052 0 0 1-2.664-.77l-.444 1.2c.647.448 1.758.77 2.83.788v1.81h1.167v-1.865c1.906-.302 2.923-1.629 2.923-3.043 0-1.594-.962-2.525-2.868-3.278"/>
		</svg>
		<ng-container  i18n="@@invoices.record_payment" >Record New Payment</ng-container>
	</h2>
	<a class="close-circle" data-dismiss="modal" aria-label="close-circle" (click)="activeModal.dismiss()">
		<svg version="1.1" x="0px" y="0px" width="14" height="14"  viewBox="0 0 14 14">
			<path class="icon-stroke" fill="none" stroke-width="2" stroke-linecap="square" d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5"/>
		</svg>
	</a>
</div>
<div class="modal-body">
	<p i18n="@@invoices.invoice_hash" >Invoice # <span>{{ invoiceNumber }}</span></p>
	<form [formGroup]="paymentForm" (ngSubmit)="submit()" class="new-record">
		<fieldset class="full-name" [ngClass]="{'has-error': submitted && paymentForm.get('client_id').errors?.required}">
			<label>
				<ng-container i18n="@@invoices.client">Client</ng-container><span class="req-star">*</span>
			</label>
			<select
				app-select2
				[options]="{
					ajax: {url: clientListApi},
					idColumn: 'id',
					textColumn: 'full_name',
					dropdownParent: 'form.new-record'
				}"
				(itemSelected)="onChangeClient($event)"
				i18n-data-placeholder="@@option.select_client" data-placeholder="Please type client name"
				[selected]="selectedClient ? {id: selectedClient.id, text: selectedClient.full_name} : null"
			 	formControlName="client_id"
		 	><option></option></select>
			<span class="field-error" i18n="@@error.required">Required</span>
		</fieldset>

		<fieldset class="full-name" [ngClass]="{'has-error': submitted && paymentForm.get('invoice_id').errors?.required}">
			<label>
				<ng-container i18n="@@invoices.invoice">Invoice</ng-container><span class="req-star">*</span>
			</label>
			<select nice-select formControlName="invoice_id" (change)="onChangeProject($event.target.value)" [attr.disabled]="!paymentForm.get('client_id').value ? true : null">
				<option [ngValue]="null" i18n="@@record_payment.select_invoice">Select Invoice</option>
				<option *ngFor="let invoice of invoices" [value]="invoice.id">{{ invoice.invoice_number ? '# '+invoice.invoice_number : 'Unknown Title' }}</option>
			</select>
			<span class="field-error" i18n="@@error.required">Required</span>
		</fieldset>

		<fieldset class="full-name" [ngClass]="{'has-error': submitted && paymentForm.get('amount').errors}">
			<label>
				<ng-container i18n="@@invoices.amount_received" >Amount Received</ng-container><span class="req-star">*</span>
			</label>
			<input type="number" formControlName="amount" name="amount-received" placeholder="0.00" appPreventScroll />

			<span class="field-error" *ngIf="paymentForm.get('amount').errors?.required" i18n="@@error.required">Required</span>
			<span class="field-error" *ngIf="paymentForm.get('amount').errors?.max" i18n="@@error.max_amount"> Amount must be less than {{ paymentForm.get('amount').errors?.max.max }} </span>
			<span class="field-error" *ngIf="paymentForm.get('amount').errors?.min" i18n="@@error.min_amount"> Amount must be greater than {{ 0 | myCurrency }} </span>

			<span class="field-error" *ngIf="paymentForm.get('amount').errors?.serverError"> {{ paymentForm.get('amount').errors?.serverError }} </span>
		</fieldset>

		<fieldset class="half">
			<label i18n="@@invoices.payment_date" >Payment Date</label>
			<div class="date-input-wrap">
				<input type="text" date-dropper data-dd-format="d/m/Y" formControlName="date" data-large-default="true" class="date-input datedropper-init" data-theme="teamup" id="paymentDate" placeholder="Select Date">
			</div>
		</fieldset>

		<fieldset class="half" [ngClass]="{'has-error': submitted && paymentForm.get('payment_type').errors?.required}">
			<label>
				<ng-container i18n="@@invoices.type">Type</ng-container><span class="req-star">*</span>
			</label>
			<select nice-select formControlName="payment_type" (change)="isNoteFieldEnabled()">
				<option [ngValue]="null" i18n="@@common.select_type">Select Type</option>
				<ng-container *ngFor="let type of paymentTypes" >
					<option [value]="type.value" *ngIf="checkOptionIsAvailable(type.value)">{{ type.label }}</option>
				</ng-container>
			</select>
			<span class="field-error" i18n="@@error.required">Required</span>
		</fieldset>

		<fieldset class="full-name" *ngIf="this.paymentForm.value.payment_type === 'other'" [ngClass]="{'has-error': submitted && paymentForm.get('other_note').errors}">
			<label i18n="@@invoices.other_note" >Note</label>
				<textarea type="text" formControlName="other_note" i18n-placeholder="@@invoices.other_note" placeholder="Note"></textarea>
				<span class="field-error" *ngIf="paymentForm.get('other_note').errors?.required" i18n="@@error.required">Required</span>
		</fieldset>

	</form>
</div>
<div class="modal-footer">
	<button type="button" (click)="submit()" class="tu-btn pink" i18n="@@button.record_payment">Record Payment</button>
</div>
